import axios from 'axios';

const BASE_URL = 'https://api.lineardevelopment.gr';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('portal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('portal_token');
      localStorage.removeItem('portal_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const portalLogin = (email: string, password: string) =>
  api.post('/portal/login', { email, password });

export const portalMe = () =>
  api.get('/portal/me');

export const portalSummary = () =>
  api.get('/portal/summary');

export const portalMonthly = () =>
  api.get('/portal/monthly');

export const portalReceipts = (params?: any) =>
  api.get('/portal/receipts', { params });

export const portalIssueReceipt = (data: any) =>
  api.post('/portal/receipts/issue', data);

export default api;
